import { colors, Icon, Tag, Text } from 'common-components';
import { PropsWithChildren, useMemo } from 'react';

export type TTag = 'positive' | 'negative' | 'neutral';

type PercentTagPropsType = {
  state: TTag
  withIcon?: boolean
};

const getTagColors = (state: TTag): { text: string; background: string } => {
  switch (state) {
    case 'positive':
      return {
        text: colors.success700,
        background: colors.success50,
      };
    case 'negative':
      return {
        text: colors.error700,
        background: colors.error50,
      };
    case 'neutral':
      return {
        text: colors.warning700,
        background: colors.warning50,
      };
    default:
      return {
        text: colors.gray700,
        background: colors.gray50,
      };
  }
};

const PercentTag = ({
  state,
  withIcon = true,
  children,
}: PropsWithChildren<PercentTagPropsType>) => {
  const tagColors = useMemo(() => getTagColors(state), [state]);

  return (
    <Tag
      color={tagColors.background}
      type="fill"
      style={{
        height: 22,
        padding: '2px 10px',
      }}
    >
      {withIcon && (
        <Icon
          color={tagColors.text}
          icon={'ArrowUp'}
          size={14}
          style={{
            transform: `rotate(${state === 'negative' ? '180' : '0'}deg)`,
          }}
        />
      )}
      <Text size="xs" strong style={{ marginLeft: withIcon ? 6 : 0, color: tagColors.text }}>
        {children}
      </Text>
    </Tag>
  );
};

export default PercentTag;
